import { atom } from 'recoil';

const authAtom = atom({
  key: 'authAtom',
  default: {
    user: null,
    jwt: null,
    isLoading: false,
    error: null,
  },
});

export { authAtom };
